import { render, staticRenderFns } from "./GoatDetails.vue?vue&type=template&id=352458ab&"
import script from "./GoatDetails.vue?vue&type=script&lang=js&"
export * from "./GoatDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports